import React from 'react';

interface Props {
  fillColor?: string;
}
function LeftChevronButton({ fillColor = 'black' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 25 24"
      fill="none">
      <path
        d="M15.1035 18L9.10352 12L15.1035 6"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LeftChevronButton;
